import { useLanguage } from '@i18n'
import './CertificateDownloadInput.css'

type CertificateDownloadInputProps = {
  buttonLabel?: string
  disabled?: boolean
  error?: string
  hideLabel?: boolean
  id: string
  label: string
  loading?: boolean
  loadingLabel?: string
  onChange: (value: string) => void
  value: string
}

export const CertificateDownloadInput = ({
  buttonLabel,
  disabled = false,
  error,
  hideLabel = false,
  id,
  label,
  loading = false,
  loadingLabel,
  onChange,
  value,
}: CertificateDownloadInputProps) => {
  const { t } = useLanguage()
  const errorId = `${id}-error`
  const resolvedButtonLabel = buttonLabel || t('certificateDownload.button')
  const resolvedLoadingLabel = loadingLabel || t('certificateDownload.loading')

  return (
    <div className="certificate-download-input">
      <label className={hideLabel ? 'visually-hidden' : undefined} htmlFor={id}>
        {label}
      </label>
      <div className="certificate-download-input__row">
        <input
          id={id}
          type="text"
          value={value}
          disabled={loading}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={error ? errorId : undefined}
          placeholder={t('certificateDownload.placeholder')}
          onChange={(event) => onChange(event.target.value)}
        />
        <button type="submit" disabled={disabled || loading}>
          <span>{loading ? resolvedLoadingLabel : resolvedButtonLabel}</span>
          <span className="certificate-download-input__icon" aria-hidden="true" />
        </button>
      </div>
      {error && (
        <div id={errorId} className="certificate-download-input__error" role="alert">
          {error}
        </div>
      )}
    </div>
  )
}
